// Máscaras e validações para formulários

export const aplicarMascaraCNPJ = (valor: string): string => {
  const numeros = valor.replace(/\D/g, '');
  return numeros
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2')
    .slice(0, 18);
};

export const aplicarMascaraTelefone = (valor: string): string => {
  const numeros = valor.replace(/\D/g, '');
  if (numeros.length <= 10) {
    return numeros
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d{1,4})/, '$1-$2')
      .slice(0, 14);
  } else {
    return numeros
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d{1,4})/, '$1-$2')
      .slice(0, 15);
  }
};

export const aplicarMascaraCEP = (valor: string): string => {
  const numeros = valor.replace(/\D/g, '');
  return numeros
    .replace(/(\d{5})(\d)/, '$1-$2')
    .slice(0, 9);
};

export const validarEmail = (email: string): boolean => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const validarCNPJ = (cnpj: string): boolean => {
  const numeros = cnpj.replace(/\D/g, '');
  
  if (numeros.length !== 14) return false;
  
  // Verificar se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(numeros)) return false;
  
  // Validação do primeiro dígito verificador
  let soma = 0;
  let peso = 5;
  for (let i = 0; i < 12; i++) {
    soma += parseInt(numeros[i]) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }
  const resto = soma % 11;
  const dv1 = resto < 2 ? 0 : 11 - resto;
  
  if (parseInt(numeros[12]) !== dv1) return false;
  
  // Validação do segundo dígito verificador
  soma = 0;
  peso = 6;
  for (let i = 0; i < 13; i++) {
    soma += parseInt(numeros[i]) * peso;
    peso = peso === 2 ? 9 : peso - 1;
  }
  const resto2 = soma % 11;
  const dv2 = resto2 < 2 ? 0 : 11 - resto2;
  
  return parseInt(numeros[13]) === dv2;
};

export const validarTelefone = (telefone: string): boolean => {
  const numeros = telefone.replace(/\D/g, '');
  return numeros.length >= 10 && numeros.length <= 11;
};

export const validarCEP = (cep: string): boolean => {
  const numeros = cep.replace(/\D/g, '');
  return numeros.length === 8;
};

export const validarSenha = (senha: string): { valida: boolean; erros: string[] } => {
  const erros: string[] = [];
  
  if (senha.length < 8) {
    erros.push('A senha deve ter pelo menos 8 caracteres');
  }
  
  if (!/[A-Z]/.test(senha)) {
    erros.push('A senha deve conter pelo menos uma letra maiúscula');
  }
  
  if (!/[a-z]/.test(senha)) {
    erros.push('A senha deve conter pelo menos uma letra minúscula');
  }
  
  if (!/\d/.test(senha)) {
    erros.push('A senha deve conter pelo menos um número');
  }
  
  if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(senha)) {
    erros.push('A senha deve conter pelo menos um símbolo');
  }
  
  return {
    valida: erros.length === 0,
    erros
  };
};
